// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T_YU","content":"styles_content__aGu6r","tableWrap":"styles_tableWrap__33JK5"};